import { TASK_CREATE } from '../../constants/CopilotInAppActionTypes';
import { normalizeObjectType, parseObjectId } from '../../utils/parserUtils';
export const taskCreate = action => {
  return {
    data: Object.assign({
      intent: TASK_CREATE,
      task: action.task
    }, action.date ? {
      due_date_time: action.date
    } : {}, action.objectId && action.objectTypeId ? {
      associated_object: {
        object_id: parseObjectId(action.objectId),
        object_type: normalizeObjectType(action.objectTypeId)
      }
    } : {}),
    text: action.text || action.task
  };
};